import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPublishCollectionChallengesRequest } from './publish-collection-challenges-request';
import type { IPublishCollectionChallengesResponse } from './publish-collection-challenges-response';
import { publishCollectionChallengesResponseSchema } from './publish-collection-challenges-response';

export async function publishCollectionChallengesApi({
  collectionId,
}: IPublishCollectionChallengesRequest): Promise<
  IValidatedResponse<IPublishCollectionChallengesResponse>
> {
  return postRequest<IPublishCollectionChallengesResponse>({
    path: `/sys/collections/${collectionId}/publish-challenges`,
    body: {},
    schema: publishCollectionChallengesResponseSchema,
  });
}
